import { render, staticRenderFns } from "./Rental10gWifiRouter.vue?vue&type=template&id=c543b046&scoped=true&"
import script from "./Rental10gWifiRouter.vue?vue&type=script&lang=ts&"
export * from "./Rental10gWifiRouter.vue?vue&type=script&lang=ts&"
import style0 from "./Rental10gWifiRouter.vue?vue&type=style&index=0&id=c543b046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c543b046",
  null
  
)

export default component.exports